/* import __COLOCATED_TEMPLATE__ from './tag-chooser-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const TagChooserRow = dt7948.c(class TagChooserRow extends SelectKitRowComponent {}, [classNames("tag-chooser-row")]);
export default TagChooserRow;